export default "__VITE_ASSET__b_kR91UY__"